import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap, Sparkles, Check, Crown } from 'lucide-react';
import { DigitalDisclaimer } from './DigitalDisclaimer';
export function Urgency() {
  const ecosystem = ['Acceso inmediato', 'Aprende desde cualquier lugar', 'Compatible con celular y computadora', 'Actualizado para 2026', 'Sistema práctico y fácil de entender', 'Diseñado para principiantes'];
  return <section className="bg-brand-green py-20 md:py-28 px-5 sm:px-6 text-white relative overflow-hidden" data-id="element-797">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden opacity-15 pointer-events-none" data-id="element-798">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-brand-gold rounded-full blur-3xl" data-id="element-799"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-800">
        <FadeIn data-id="element-801">
          {/* Pre-title badge */}
          <div className="inline-flex items-center justify-center gap-2 bg-brand-gold/15 border border-brand-gold/40 rounded-full px-5 py-2 mb-6" data-id="element-802">
            <Sparkles className="w-3.5 h-3.5 text-brand-gold" data-id="element-803" />
            <span className="text-[11px] sm:text-xs font-bold tracking-[0.18em] uppercase text-brand-gold" data-id="element-804">
              Decide cómo quieres avanzar
            </span>
          </div>

          {/* Title */}
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-[1.05] tracking-tight" data-id="element-805">
            Hoy puedes seguir viendo videos sueltos sin entender nada…
          </h2>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-white/80 mb-5 leading-relaxed max-w-2xl mx-auto" data-id="element-806">
            …o comenzar a aprender un{' '}
            <span className="font-semibold text-brand-gold" data-id="element-807">
              sistema práctico y estructurado
            </span>{' '}
            que te enseñe paso a paso cómo funciona realmente Amazon FBA + FBM
            desde cero.
          </p>
          <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-2xl mx-auto mb-3" data-id="element-808">
            Miles de personas quieren generar ingresos online… pero muy pocas
            aprenden una habilidad real.
          </p>
          <p className="text-sm md:text-base text-white/55 italic leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-809">
            Hoy puedes comenzar desde casa, a tu ritmo y con un sistema diseñado
            especialmente para principiantes.
          </p>

          {/* Ecosystem highlight card */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 mb-10 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-810">
            <div className="flex items-center justify-center gap-2 mb-5" data-id="element-811">
              <Crown className="w-4 h-4 text-brand-gold" data-id="element-812" />
              <p className="text-xs sm:text-sm font-bold tracking-[0.18em] uppercase text-brand-gold" data-id="element-813">
                Todo lo que necesitas para comenzar
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-left" data-id="element-814">
              {ecosystem.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-815">
                  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-brand-gold/20 border border-brand-gold/40 flex-shrink-0" data-id="element-816">
                    <Check className="w-3 h-3 text-brand-gold" strokeWidth={3} data-id="element-817" />
                  </span>
                  <span className="text-sm md:text-[15px] text-white/90 font-medium leading-snug" data-id="element-818">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Urgency text */}
          <div className="mb-9 max-w-xl mx-auto" data-id="element-819">
            <p className="text-base md:text-lg text-brand-gold font-semibold mb-1.5" data-id="element-820">
              ⚠️ El precio actual es promocional y puede cambiar próximamente.
            </p>
            <p className="text-sm md:text-base text-white/65" data-id="element-821">
              Empieza hoy mientras el acceso sigue disponible.
            </p>
          </div>

          {/* Buttons block */}
          <div className="max-w-2xl mx-auto" data-id="element-822">
            {/* Guide line */}
            <div className="text-center mb-6" data-id="element-823">
              <p className="text-sm md:text-base font-semibold text-white mb-2" data-id="element-824">
                ¿Cuál sistema quieres comenzar hoy?
              </p>
              <p className="text-xs md:text-sm text-white/55 leading-relaxed" data-id="element-825">
                🏆 Amazon Master System™ 2026 (Más completo) · 🚀 Sistema
                Completo FBA + FBM · 📦 Cursos individuales
              </p>
            </div>

            {/* HERO — Amazon Master System (most visible) */}
            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/amazon-master-system%E2%84%A2-2026-fba-fbm-wholesale-bonos-premium', '_blank', 'noopener,noreferrer')} className="w-full flex flex-col items-center bg-brand-gold hover:bg-brand-gold/90 text-brand-green font-bold px-10 py-6 shadow-2xl shadow-brand-gold/40 ring-2 ring-brand-gold/60 mb-5" data-id="element-826">
              <span className="text-base md:text-xl leading-tight" data-id="element-827">
                🏆 AMAZON MASTER SYSTEM™ 2026
              </span>
              <span className="block text-[11px] md:text-xs font-semibold text-brand-green/75 mt-1 normal-case tracking-normal" data-id="element-828">
                Incluye FBA + FBM + Wholesale + Software Stack + Arbitrage
              </span>
            </Button>

            {/* Sistema Completo */}
            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026', '_blank', 'noopener,noreferrer')} className="w-full bg-brand-gold/90 hover:bg-brand-gold text-brand-green text-base md:text-lg font-bold px-10 py-5 shadow-xl shadow-brand-gold/20 ring-1 ring-brand-gold/30 mb-5" data-id="element-829">
              🚀 QUIERO EL SISTEMA COMPLETO AMAZON
            </Button>

            {/* Secondary buttons — side by side on sm+ */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5" data-id="element-830">
              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank', 'noopener,noreferrer')} className="w-full bg-transparent hover:bg-white/10 text-white/90 border border-white/25 text-sm md:text-base px-6 py-3.5" data-id="element-831">
                📦 Solo Amazon FBA
              </Button>
              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/aprende-a-vender-en-amazon-fbm-desde-cero', '_blank', 'noopener,noreferrer')} className="w-full bg-transparent hover:bg-white/10 text-white/90 border border-white/25 text-sm md:text-base px-6 py-3.5" data-id="element-832">
                📦 Solo Amazon FBM
              </Button>
            </div>

            {/* Wholesale */}
            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-wholesale-desde-cero-2026', '_blank', 'noopener,noreferrer')} className="w-full bg-transparent hover:bg-white/10 text-white/90 border border-white/25 text-sm md:text-base px-6 py-3.5 mb-5" data-id="element-833">
              📦 Amazon Wholesale™
            </Button>

            {/* Trust badges */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white/50 text-xs mt-8 pt-6 border-t border-white/10" data-id="element-834">
              <span className="flex items-center gap-1.5 tracking-wide" data-id="element-835">
                <Zap className="w-3.5 h-3.5 text-brand-gold" data-id="element-836" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-1.5 tracking-wide" data-id="element-837">
                <Download className="w-3.5 h-3.5 text-brand-gold" data-id="element-838" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-1.5 tracking-wide" data-id="element-839">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-gold" data-id="element-840" />
                COMPRA SEGURA
              </span>
            </div>

            <DigitalDisclaimer variant="light" data-id="element-841" />
          </div>
        </FadeIn>
      </div>
    </section>;
}